module.exports = __webpack_public_path__ + "img/3.135c73a8.jpg";